/**
 * What signing out removes from this browser.
 *
 * Signing out used to call localStorage.clear(), which also wiped the
 * Super Assistant's settings — model, effort and personal instructions — so
 * they were gone the next time the person opened the assistant (#4232).
 *
 * Now everything is still cleared EXCEPT the assistant preferences below.
 * Personal instructions are already keyed per account
 * (`agent-chat-instructions:<sub>`), so the next person to sign in on a
 * shared machine never sees them; model and effort are not sensitive.
 * Anything else (the sign-in session, the ADO token on Client Wins, …) is
 * still removed, exactly as before.
 */
export const KEEP_ON_SIGN_OUT = [
    /^agent-chat-model$/,
    /^agent-chat-effort$/,
    /^agent-chat-instructions:/,
];

export const clearOnSignOut = (storage = window.localStorage) => {
    try {
        const doomed = [];
        for (let i = 0; i < storage.length; i += 1) {
            const key = storage.key(i);
            if (key !== null && !KEEP_ON_SIGN_OUT.some((re) => re.test(key))) doomed.push(key);
        }
        doomed.forEach((key) => storage.removeItem(key));
    } catch {
        // Private window or blocked storage: nothing was persisted to clear.
    }
};
